import {registerCustomHook} from "../lib/core";
import {loadPosts} from "./actions";
import {store} from "../lib/store";

//Custom loading hooks
export const initCustomHooks = () => {
	//registerCustomHook('onNotFoundLoadingPage', (params) => {});
	// registerCustomHook('onBeforeEvaluatingPage', (params) => {
    //     if (!params.args.page && params.args.hash && store.getState().pageState.page) {
    //         return false;
    //     }
    // });
	//registerCustomHook('onBeforeLoadingPage', (params) => {});
	registerCustomHook('onSuccessLoadingPage', (params) => {

        // let params.page.parent = params.response_object.parent;
        params.page.parent = params.response_object.parent;

        if ((params.page.template === 'news') && !store.getState().newsState.news) {
            loadPosts(params.dispatch);
        }



    });
	registerCustomHook('onSettingsLoaded', (params) => {
        if (params.rsp.custom_data?.kwh_comparison) {
            params.dispatch({
                type: 'CUSTOM_DATA_KWH',
                data: params.rsp.custom_data.kwh_comparison
            })
        }

    });
    //registerCustomHook('onComponentCookieAccept', (accepted) => {});
};



